var enums = Object.create(null);

enums.TICKET_CONTROL_STATE = {
  VALID: { name: 'À utiliser', value: 'valid' },
  USED: { name: 'Utilisé', value: 'used' },
  EXPIRED: { name: 'Expiré', value: 'expired' }
};

// Types de tickets créés automatiquement s'ils n'existent pas, la valeur est le nom du type
enums.SPECIAL_TICKET_TYPE_NAMES = { QUIZ_ROOM: 'QuizRoom' };

// Nombre maximum de tickets créés par appel de l'API
enums.API_MAX_TICKETS_PER_CREATION = 5;

module.exports = enums;
